import { render, staticRenderFns } from "./SubContractorsTypesForm.vue?vue&type=template&id=16d5d4a6"
import script from "./SubContractorsTypesForm.vue?vue&type=script&lang=js"
export * from "./SubContractorsTypesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports